// @flow

import * as React from 'react';

import ParkChicagoLogo from '../../assets/park-chicago-logo';

import { MobileHeader, Content, Title } from './';

const Layout = (props: {|
  title: string,
  header?: string,
  children?: React.Node,
|}) => [
  <MobileHeader key="header">{props.title}</MobileHeader>,
  <Content key="content">
    <ParkChicagoLogo />
    <Title>{props.header}</Title>
    {props.children}
  </Content>,
];

export default Layout;



// WEBPACK FOOTER //
// ./src/Auth/components/Layout.js